export default __webpack_public_path__ + "static/media/cog.9588ad82.svg";